<template>
  <section
    class="multiple-images-slide"
    v-if="images"
  >
    <image-aside-slide
      class="main-slide"
      v-bind:image-src="mainImage.image"
      v-bind:image-alt="mainImage.alt_text"
      v-bind:auto-full-screen="false"
      v-bind:tag="'div'"
    >
      <aside
        class="image-wrapper"
        v-for="image in restImages"
        v-bind:key="image.id"
      >
        <img
          v-lazy="image.image"
          v-bind:alt="image.alt_text"
        >
      </aside>
    </image-aside-slide>
    <div class="under-hello-slide">
      <main-text-block
        v-bind:title="mainImage.title"
        v-bind:text="mainImage.description"
      ></main-text-block>
    </div>
  </section>
</template>

<script>
import ImageAsideSlide from './utils/ImageAsideSlide'
import MainTextBlock from './main/MainTextBlock'

export default {
  name: 'MainSlideMultipleImages',
  props: ['images'],
  components: {ImageAsideSlide, MainTextBlock},
  data: function () {
    return {}
  },
  computed: {
    mainImage: function () {
      return this.images[0]
    },
    restImages: function () {
      return this.images.slice(1)
    }
  }
}
</script>

<style scoped lang="scss">
  .multiple-images-slide {
    .image-wrapper > img {
      display: block;
      width: 100%;
      @media only print {
        display: none;
      }
    }
    .under-hello-slide {
      @include page-block-vertical-padding();
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/MainSlideMultipleImages.vue